import type { AppRouter } from '@fold-and-flow/api/src/trpc/router'
import { createTRPCClient, httpBatchLink } from '@trpc/client'
import { createTRPCReact } from '@trpc/react-query'
import superjson from 'superjson'

export const trpc = createTRPCReact<AppRouter>()

export function createTrpcClient() {
  const apiBase = import.meta.env.VITE_API_URL ?? ''
  return createTRPCClient<AppRouter>({
    links: [
      httpBatchLink({
        url: `${apiBase}/trpc`,
        transformer: superjson,
        fetch: (url, options) =>
          fetch(url, {
            ...options,
            signal: options?.signal ?? null,
            credentials: 'include',
          }),
      }),
    ],
  })
}
